<div class="app-dialog-container-wrapper">
    <ng-template appModalDialogSlot></ng-template>
</div>
